<template>
  <MainBase>
    <div class="m_convert_cntr g_clr">
      <div class="mc_left_nav g_fl">
        <div v-for="(nav, index) in navList" :key="index" class="mlnav_bl">
          <h2 class="mlnav_title">{{ nav.parent.name }}</h2>
          <ul>
            <li v-for="(item, i) in nav.children" :key="i">
              <a
                :class="{ active: currentRouteName === getRotuerInfo(item.routeName).name && groupName === (item.query || {}).group_name }" class="mlnav_item"
                @click="clickItem({ routeName: item.routeName, query: item.query, report: item.report })">
                {{ item.name }}<i v-if="item.iconName" :class="item.iconName" class="common_icons ic" /></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="mc_right_convert g_fr">
        <router-view />
      </div>
    </div>
  </MainBase>
</template>

<script>
import MainBase from '@/components/layout/MainBase'

import { strictExtend } from '@shared/utils/base/index.js'

import { NAV_LIST } from '@/config/config'

export default {
  components: { MainBase },

  data () {
    return {
      navList: strictExtend(NAV_LIST),
    }
  },

  computed: {
    currentRouteName () {
      return this.$route.name
    },

    groupName () {
      return this.$route.query.group_name
    }
  },

  methods: {
    clickItem ({ routeName, query = {}, report = {} } = {}) {
      const timeStr = `${new Date().getTime()}`
      this.$router.push({
        name: routeName,
        query: {
          ...query,
          _t: timeStr.substring(timeStr.length - 4)
        }
      })
    },

    getRotuerInfo (routeName) {
      return this.$router.match({ name: routeName })
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/scss/common_icons.scss';

  .m_convert_cntr { width: 1180px; padding: 30px 0 164px 0; margin: 0 auto;
    .mc_left_nav { width: 160px; }

    .mlnav_bl { color: #666;
      a { color: #666; }
      .mlnav_title, .mlnav_item { display: block; height: 50px; line-height: 50px; text-indent: 31px; background: #548ef8; }
      .mlnav_title { font-size: 18px; font-weight: bold; color: #fff; }
      .mlnav_item { position: relative; font-size: 16px; background: #f9f9f9; border-left: 3px solid #f9f9f9;
        &:hover, &.active { background: #d8e4f9; border-color: #a2c3ff;
          &::before { position: absolute; top: 50%; left: 0; width: 0; margin-top: -4px; content: ' '; border-color: #d8e4f9 #d8e4f9 #d8e4f9 #a2c3ff; border-style: solid; border-width: 4px; }
        }
        .ic { position: relative; top: -2px; vertical-align: middle; }
      }
    }

    .mc_right_convert { width: 990px;
      .convert_ad { display: inline-block; margin-bottom: 15px; overflow: hidden; border-radius: 4px;}
    }
  }
</style>
